import React from 'react'
import ExpensesNeedsApproval from 'src/app/ExpensesNeedsApproval/ExpensesNeedsApproval'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { expensesNeedsApprovalRouteProps } from 'src/navigation/routeProps'

const ExpensesNeedsApprovalAppRoute: AppRoute = {
  routeProps: expensesNeedsApprovalRouteProps,
  component: <ExpensesNeedsApproval />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ExpensesNeedsApprovalAppRoute
